"use client";
import { NavItem } from "../types";
import { MobileNavItem } from "./MobileNavItem";
import { HamburgerButton } from "@/components/ui";
import { Accordion } from "@/components/ui/accordion";
import Link from "next/link";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { useState } from "react";
import { CONFIG } from "@/constants/config";

interface MobileNavbarProps {
	navItems: NavItem[];
	currentPath: string;
	extraNavItems: NavItem[];
}

export const MobileNavbar = ({
	navItems,
	currentPath,
	extraNavItems,
}: MobileNavbarProps) => {
	const [isOpen, setIsOpen] = useState(false);

	const toggleSheet = () => setIsOpen((prev) => !prev);
	const closeSheet = () => setIsOpen(false);

	return (
		<Sheet open={isOpen} onOpenChange={setIsOpen}>
			<HamburgerButton
				isOpen={isOpen}
				onOpen={toggleSheet}
				className="lg:hidden block bg-transparent border border-border hover:border-ink p-2 aspect-square rounded-sm transition-all duration-300"
			/>
			<SheetContent
				side="left"
				className="w-72 p-0 flex flex-col bg-cream border-r border-border"
				aria-label="Menú de navegación"
			>
				<div className="border-b border-border">
					<Link
						href={"/"}
						onClick={closeSheet}
						aria-label="Aranzazu Gutiérrez, ir a la página principal"
						className="h-fit flex justify-center items-center p-5"
					>
						<span className="font-display text-lg text-ink leading-none tracking-tight">
							Aranzazu Gutiérrez
						</span>
					</Link>
				</div>

				<div className="flex flex-1 overflow-y-auto flex-col">
					<div className="p-4">
						<Accordion
							type="multiple"
							className="flex flex-col gap-1"
							aria-label="Menú de navegación principal"
						>
							{navItems.map((item) => (
								<MobileNavItem
									key={item.path}
									item={item}
									currentPath={currentPath}
									onNavigate={closeSheet}
								/>
							))}
						</Accordion>
					</div>

					{extraNavItems.length > 0 && (
						<>
							<div className="px-4">
								<div className="w-full h-px bg-border" />
							</div>
							<div className="p-4">
								<Accordion type="multiple" className="flex flex-col gap-1">
									{extraNavItems.map((item) => (
										<MobileNavItem
											key={item.path}
											item={item}
											currentPath={currentPath}
											onNavigate={closeSheet}
										/>
									))}
								</Accordion>
							</div>
						</>
					)}
				</div>

				<div className="p-4 border-t border-border">
					<p className="font-body text-sm text-muted-foreground text-center">
						© {new Date().getFullYear()} {CONFIG.AUTHOR}
					</p>
				</div>
			</SheetContent>
		</Sheet>
	);
};
